<template>
  <v-container fluid>
    <v-expand-transition>
      <div v-if="showTimelineChart" id="chart">
        <releases-chart
          :tab="selectedTab"
          :releases="releases"
        ></releases-chart>
      </div>
    </v-expand-transition>
    <v-card v-if="!loading && errors.length === 0" class="mx-auto" outlined>
      <v-tabs
        v-model="selectedTab"
        background-color="accent-4"
        center-active
        dark
      >
        <v-tab :key="env" v-for="(_, env) in releases">{{ env }}</v-tab>
        <v-autocomplete
          solo
          chips
          multiple
          clearable
          v-model="artifactsFilter"
          :items="searchItems[searchZone]"
        ></v-autocomplete>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              x-small
              class="mt-4 mr-2"
              color="white"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>
                mdi-filter
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="zone in Object.keys(searchItems)"
              :key="zone"
              v-on:click="searchZone = zone"
              link
            >
              <v-list-item-title>
                <div
                  :class="searchZone == zone ? 'font-weight-bold' : ''"
                  class="text-sm-caption"
                  v-text="zone"
                ></div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          dark
          icon
          x-small
          class="mt-4 mr-2"
          v-on:click="showTimelineChart = !showTimelineChart"
          color="white"
          title="Show deployment timeline"
        >
          <v-icon dark>
            mdi-chart-gantt
          </v-icon>
        </v-btn>
      </v-tabs>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item nav :key="env" v-for="(release, env) in releases">
          <v-container fluid>
            <v-row>
              <v-col
                cols="12"
                md="4"
                xl="3"
                v-for="current in release.current.filter(
                  comp =>
                    searchZone == comp.zone &&
                    (artifactsFilter.length == 0 ||
                      artifactsFilter.indexOf(comp.artifact) >= 0)
                )"
                :key="current.id"
              >
                <artifact-card
                  :release="current"
                  :health="workerHealth"
                  :infos="workerInfos"
                  :previous="release.previous"
                ></artifact-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-container v-if="loading">
      <v-card flat class="float-left" max-width="300" elevation="0">
        <v-card-title>
          Please wait
        </v-card-title>
        <v-card-subtitle>Loading environments info...</v-card-subtitle>
      </v-card>
    </v-container>
    <v-container v-if="errors.length != 0">
      <v-card flat max-width="300" elevation="0">
        <v-card-title>
          Try again later!
        </v-card-title>
        <v-card-subtitle
          >Could not load releases info this time
        </v-card-subtitle>
        <v-card-text class="font-italic caption">{{ errors[0] }}</v-card-text>
      </v-card>
    </v-container>

    <releases-summary
      :tab="selectedTab"
      :loading="loading"
      :releases="releases"
      :zone="searchZone"
    ></releases-summary>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ArtifactCard from './Releases/ArtifactCard.vue';
import ReleasesChart from './Releases/ReleasesChart.vue';
import ReleasesSummary from './Releases/ReleasesSummary.vue';
const { mapState: mapStateConfig } = createNamespacedHelpers('config');

const { mapState, mapActions } = createNamespacedHelpers('releases');

export default {
  components: {
    ArtifactCard,
    ReleasesChart,
    ReleasesSummary
  },
  name: 'Releases',
  async created() {
    await this.getADOReleases();
    this.getHealthInfo();
  },
  methods: {
    ...mapActions(['getADOReleases', 'getWorkerInfos', 'getWorkerHealth']),
    getHealthInfo() {
      const selectedEnv = Object.keys(this.releases)[this.selectedTab];
      this.getWorkerInfos({
        artifacts: this.releases[selectedEnv].current,
        env: Object.keys(this.releases)[this.selectedTab]
      }).then(() => {
        console.log('loaded workers /infos');
      });
      this.getWorkerHealth({
        artifacts: this.releases[selectedEnv].current,
        env: Object.keys(this.releases)[this.selectedTab]
      }).then(() => {
        console.log('loaded workers /health');
      });
    }
  },
  data: function() {
    return {
      selectedTab: 0,
      showTimelineChart: false,
      artifactsFilter: [],

      toDeployVersions: {}
    };
  },
  watch: {
    selectedTab() {
      this.getHealthInfo();
    }
  },
  computed: {
    ...mapState([
      'releases',
      'loading',
      'workerInfos',
      'workerHealth',
      'errors'
    ]),
    ...mapStateConfig(['currentDivision']),
    searchZone() {
      return this.currentDivision;
    },
    searchItems() {
      const components = {};
      if (this.selectedTab != null) {
        const currentArtifacts = this.releases[
          Object.keys(this.releases)[this.selectedTab]
        ].current;
        for (let idx = 0; idx < currentArtifacts.length; idx++) {
          const zone = currentArtifacts[idx].zone;
          if (!components[zone]) components[zone] = [];
          components[zone].push(currentArtifacts[idx].artifact);
        }
      }
      return components;
    }
  }
};
</script>

<style>
.highlighted {
  background-color: #ededf3;
}
</style>
